import { DevicesRepository, ActivationCodesRepository, LicensesRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { DevicesProcessor } from 'common/repositoryProcessors/index';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$state', '$filter'];

let _$scope;
let _$filter;
// let _Util;

class LastDeviceDetailsController {

    constructor($scope, $state, $filter) {

        _$scope = $scope;
        _$filter = $filter;
        _$scope.licenses = LicensesRepository.getAll();
        _$scope.activationCodes = ActivationCodesRepository.getAll();
        _$scope.brandName = CWCONFIG.partnerConfig.name;
        const devicesObservable = DevicesRepository.getObservable();

        devicesObservable.subscribe(this.onNextDevice, () => { }, () => { });

        $scope.deployOnCategory = (category) => {

            $state.go('root.dashboard.home.ltb.deploy', {
                ltb: 'deploy',
                resourceId: 'new',
                deviceCategory: category,
            }, {
                reload: false,
            });

            $scope.sendDevicesMixpanel('Add Device');

        };

        $scope.sendDevicesMixpanel = (buttonLabel) => {

            Mixpanel.send('ConnectWeb Home Click', {
                Label: 'My devices',
                'Button label': buttonLabel,
            });

        };

    }

    onNextDevice() {

        const devices = DevicesRepository.getVisibleDevices();
        if (devices.length > 0) {

            let processedDevice;
            const latestDate = devices.map(e => e.attributes.date_added).sort().reverse()[0];
            _$scope.devicesLength = devices.length;

            const lastDeviceAdded =
                devices.find(device => device.attributes.date_added === latestDate);
            lastDeviceAdded.name = _$filter('deviceName')(lastDeviceAdded);

            const device = [];
            device[0] = lastDeviceAdded;
            processedDevice = DevicesProcessor.detectLicenseType(device);
            processedDevice = DevicesProcessor.detectFreeProducts(processedDevice);

            [_$scope.lastDeviceAdded] = processedDevice;

        }

    }

}


class LastDeviceDetailsDirective {

    constructor() {

        this.template = require('./last-device-details.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, $state, $filter) =>
            new LastDeviceDetailsController($scope, $state, $filter));
        this.controller = _controllerDependencies;
        this.controllerAs = 'lastDeviceDetailsCtrl';

    }

}

_directiveDependencies.push(() => new LastDeviceDetailsDirective());


angular.module('directives')
    .directive('lastDeviceDetails', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/last-device-details/last-device-details.js